import { styled, Divider } from "@mui/material";

export const DividerWrapper = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0),
}));
